import { Box, Divider, Text } from '@chakra-ui/react'
import { useFormsView, useUpdateDoc } from '@hb/react-web'
import { NoteForm } from '@hb/react-web/src/components/forms/NoteForm'

export const AnythingElseNote = () => {
  const { assessment, questionnaireSummaryComplete } = useFormsView()
  const { ref, assessmentData } = assessment ?? {}
  const { questionnaireNote } = assessmentData ?? {}
  const update = useUpdateDoc('note')
  if (!questionnaireSummaryComplete) return null

  return (
    <>
      <Divider />
      <Box w="100%" py={3} px={2}>
        <Text mb={1} px={2} fontFamily="Hero-New" fontWeight={400}>
          Is there anything else you would like to add regarding your pregnancy or coverage?
        </Text>
        <NoteForm
          note={questionnaireNote}
          placeholderAbove={false}
          boxProps={{ background: 'transparent', boxShadow: 'none', p: 0 }}
          placeholder="Additional notes"
          onSubmit={data => update(ref, 'questionnaireNote', data)}
        />
      </Box>
    </>
  )
}
